/** Öffentliche Ziel-URLs für Auth-/Login-Branding (keine Secrets). */
function tid(s) {
  const t = String(s ?? "").trim();
  return t || null;
}

/**
 * Produkt-Link (Login-Footer links).
 * Kein Fallback auf fremde WireTrack-Instanzen — nur explizite Vite-ENV oder leer.
 */
export function getLoginWireTrackInfoUrl() {
  try {
    return tid(import.meta.env?.VITE_LOGIN_WIRETRACK_URL) ?? "";
  } catch {
    return "";
  }
}

/** Entwickler-Link (Roos Studio). Standard laut Produktkonfiguration. */
export function getLoginRoosStudioUrl() {
  try {
    const v = tid(import.meta.env?.VITE_LOGIN_ROOS_STUDIO_URL);
    return v ?? "https://www.roosstudio.ch";
  } catch {
    return "https://www.roosstudio.ch";
  }
}
